define(['edge/platform/base/BaseCtrl', 'underscore'], (BaseCtrl)=> {
    /*
     The information being collected on this page is covered by PCI-DSS.
     It is the customer's responsibility to ensure that any security/data protection measures that are required are implemented.
     Data from this page should only ever be transmitted over HTTPS.
     */
    const fn = ($scope, StateUtils, $state, RootStates)=> {
        const ctrl = Object.create(BaseCtrl);
        const submissionVM = StateUtils.dataForState('baseQnbWizard').model;

        //work around for ui-router issue abstract base state and child state without url causes infinite loop
        //so we have to make this base state concrete. But if we just refresh the browser here we need to redirect to home page.
        if (!submissionVM) {
            $state.go(RootStates.home);
        }

        return ctrl.create($scope);
    };
    fn.$inject = ['$scope', 'StateUtils', '$state', 'state_plugin_config'];

    return fn;
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/common/controllers/BaseQnbWizardCtrl.js
 **/